(() => {
  if (window.shippingEstimatorLoaded) return;
  window.shippingEstimatorLoaded = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-shipping-calculate]');
    if (!button) return;

    const estimator = button.closest('[data-shipping-estimator]');
    const input = estimator?.querySelector('[data-shipping-zip]');
    const results = estimator?.querySelector('[data-shipping-results]');
    const zip = input?.value.trim();

    if (!input || !results) return;

    if (!/^\d{5}(-\d{4})?$/.test(zip)) {
      results.textContent = 'Please enter a valid US ZIP code.';
      input.focus();
      return;
    }

    button.disabled = true;
    results.textContent = 'Calculating shipping…';

    try {
      const fiveDigitZip = zip.slice(0, 5);

      // Automatically look up the state from the ZIP code.
      const locationResponse = await fetch(
        `https://api.zippopotam.us/us/${encodeURIComponent(fiveDigitZip)}`
      );

      if (!locationResponse.ok) {
        throw new Error('ZIP code not found');
      }

      const location = await locationResponse.json();
      const state = location.places?.[0]?.state;

      if (!state) {
        throw new Error('State could not be determined');
      }

      const parameters = new URLSearchParams({
        'shipping_address[country]': 'United States',
        'shipping_address[province]': state,
        'shipping_address[zip]': fiveDigitZip,
      });

      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(
        `${root}cart/shipping_rates.json?${parameters.toString()}`,
        {
          headers: {
            Accept: 'application/json',
          },
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Shopify returned ${response.status}: ${errorText}`);
      }

      const data = await response.json();
      const rates = data.shipping_rates || [];

      if (!rates.length) {
        results.textContent =
          'No shipping options were found for this ZIP code.';
        return;
      }

      results.replaceChildren();

      rates.forEach((rate) => {
        const line = document.createElement('p');
        const name = document.createElement('span');
        const price = document.createElement('strong');

        line.className = 'shipping-estimator__rate';
        name.textContent = `${rate.name}: `;
        price.textContent = `$${rate.price}`;

        line.append(name, price);
        results.append(line);
      });
    } catch (error) {
      console.error('Shipping estimator error:', error);
      results.textContent =
        error.message === 'ZIP code not found'
          ? 'Please enter a valid US ZIP code.'
          : 'Shipping could not be calculated. Please try again.';
    } finally {
      button.disabled = false;
    }
  });
})();